import { UndefinedInitialDataOptions, useQuery } from "@tanstack/react-query";
import { QueryTags } from "../../../../consts";
import { WorkerQueryOptions } from "../../../../libs/workers/types";
import {
  StatsQueryProps,
  StatsQueryResult,
  StatsQueryTags,
  StatsQueryType,
} from "./types";
import { statsWorkerQuery } from "./utils";

export type HookOptions<T extends StatsQueryType> = Omit<
  UndefinedInitialDataOptions<StatsQueryResult<T>>,
  "queryKey" | "queryFn"
>;

export function useStatsQuery<T extends StatsQueryType>(
  payload: {
    type: T;
    data: StatsQueryProps<T>;
    opts?: WorkerQueryOptions;
  },
  opts: HookOptions<T> = {}
) {
  return useQuery({
    queryKey: [
      QueryTags.SERVICE_WORKER_BASED,
      StatsQueryTags.STATS_MODULE_BASED,
      payload.type,
      JSON.stringify(payload.data),
      JSON.stringify(payload.opts),
    ],
    queryFn: () => statsWorkerQuery(payload.type, payload.data, payload.opts),
    staleTime: Infinity,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    refetchOnReconnect: false,
    ...opts,
  });
}
